import { render } from "./SurveyMultipleChoice.vue?vue&type=template&id=3ef34d64&scoped=true"
import script from "./SurveyMultipleChoice.vue?vue&type=script&lang=js"
export * from "./SurveyMultipleChoice.vue?vue&type=script&lang=js"

import "./SurveyMultipleChoice.vue?vue&type=style&index=0&id=3ef34d64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef34d64"]])

export default __exports__